// ciclo-vida-02 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "%{arg1} a %{arg2} dias": "%{arg1} a %{arg2} días",
    "%{n} dias": "%{n} días",
    "até %{arg1} dias": "hasta %{arg1} días",
    "mais de %{arg1} dias": "más de %{arg1} días",
};

export default catalogo;
